$bog_blitz_lobby_game $mol_view
	land_id \
	session null
	quiz_data null
	game_state \
	current_question null
	current_question_text \
	my_player null
	my_answers null
	is_host false
	paused_at 0
	manual_mode false
	state_reading @ \Read the question
	state_answering @ \Time to answer!
	state_reveal @ \Correct answer
	state_leaderboard @ \Leaderboard
	state_final @ \Final Results
	state_paused @ \Paused
	state_label \
	option_keys /string
	round_start 0
	duration 0
	total_questions 0
	current_question_index 0
	players_dict null
	my_lord_str \
	countdown_number 0
	countdown_text \
	Countdown_number $mol_paragraph
		title <= countdown_text
	sub <= game_content /
	Pause_button $mol_button_minor
		title <= pause_label @ \Pause
		click? <=> pause_click?event null
	Resume_button $mol_button_minor
		title <= resume_label @ \Resume
		click? <=> resume_click?event null
	Next_button $mol_button_major
		title <= next_label @ \Next
		click? <=> next_click?event null
	question_type \choice
	question_content /
		<= Timer $bog_blitz_lobby_game_timer
			round_start <= round_start
			duration <= duration
			paused_at <= paused_at
		<= Host_controls $mol_view
			sub <= host_controls /
		<= State $mol_paragraph
			title <= state_label
		<= Question_image $mol_image
			uri <= question_image_uri \
		<= Question $mol_paragraph
			title <= current_question_text
		<= Answer_area $mol_view
			sub <= answer_views /
		<= Countdown $mol_view
			sub <= countdown_content /
	Answer_input $mol_string
		hint @ \Type your answer...
		value? <=> text_draft? \
		enabled <= text_input_enabled true
		submit?event <=> text_submit?event null
	leaderboard_content /
		<= Leaderboard_timer $bog_blitz_lobby_game_timer
			round_start <= round_start
			duration <= duration
			paused_at <= paused_at
		<= Host_controls $mol_view
			sub <= host_controls /
		<= State $mol_paragraph
			title <= state_label
		<= Leaderboard $bog_blitz_lobby_game_leaderboard
			players_dict <= players_dict
			my_lord_str <= my_lord_str \
			is_host <= is_host
	final_content /
		<= State $mol_paragraph
			title <= state_label
		<= Final $bog_blitz_lobby_game_leaderboard
			players_dict <= players_dict
			my_lord_str <= my_lord_str \
			is_host <= is_host
		<= Reactions_board $bog_blitz_lobby_game_reactboard
			players_dict <= players_dict
	reveal_correct_text \
	Reveal_correct $mol_paragraph
		title <= reveal_correct_text
	Submit_answer $mol_button_major
		title <= submit_label @ \Submit
		click? <=> submit_answer?event null
		enabled <= submit_enabled true
	Option*0 $bog_blitz_lobby_game_option
		selected <= option_selected* \false
		correct <= option_correct* \
		enabled <= option_enabled* true
		title <= option_text* \
		image_uri <= option_image_uri* \
		click? <=> option_click*? null
